import React from "react";
import { useTranslation } from "react-i18next";
import coveragePhoto from "../../img/trade/coverage-photo.jpg";
import coinIcon from "../../img/trade/coin.svg";
import chartIcon from "../../img/trade/chart.svg";
import clockIcon from "../../img/trade/clock.svg";

const FEATURES = [
  { iconSrc: coinIcon, titleKey: "trade.coverage.f1.title", descKey: "trade.coverage.f1.desc" },
  { iconSrc: chartIcon, titleKey: "trade.coverage.f2.title", descKey: "trade.coverage.f2.desc" },
  { iconSrc: clockIcon, titleKey: "trade.coverage.f3.title", descKey: "trade.coverage.f3.desc" },
];

function Coverage() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[40px] xl:gap-[60px]">

        {/* Header */}
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-[20px]">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none xl:max-w-[504px]">
            {t("trade.coverage.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[602px]">
            {t("trade.coverage.desc")}
          </p>
        </div>

        {/* Body */}
        <div className="flex flex-col xl:flex-row gap-[40px] xl:gap-[101px] xl:items-center">
          {/* Photo */}
          <div className="w-full h-[294px] xl:w-[519px] xl:h-[436px] xl:shrink-0 rounded-[20px] overflow-hidden">
            <img src={coveragePhoto} alt="" className="w-full h-full object-cover" />
          </div>

          {/* Features */}
          <div className="flex flex-col gap-[20px] xl:gap-[40px] flex-1">
            {FEATURES.map((f, i) => (
              <React.Fragment key={i}>
                <div className="flex gap-[20px] xl:gap-[40px] items-center">
                  <div className="bg-[#ededed] flex items-center justify-center rounded-[21px] xl:rounded-[28px] shrink-0 w-[42px] h-[42px] xl:w-[56px] xl:h-[56px] p-[9px] xl:p-[13px]">
                    <img src={f.iconSrc} alt="" className="w-full h-full" />
                  </div>
                  <div className="flex flex-col gap-[12px] flex-1">
                    <h3 className="font-['Montserrat'] font-semibold text-[16px] xl:text-[20px] text-[#0a0a0a] leading-normal">
                      {t(f.titleKey)}
                    </h3>
                    <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#aaa] leading-[1.4]">
                      {t(f.descKey)}
                    </p>
                  </div>
                </div>
                {i < FEATURES.length - 1 && <div className="h-[1px] bg-[#e5e5e5]" />}
              </React.Fragment>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default Coverage;
